import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailFormatValidator(control: AbstractControl): ValidationErrors | null {
  const pattern =
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9-]+\.)+[a-z]{2,}$/i;

  const value = (control.value || '').trim();
  const isValid = pattern.test(value);

  if (!isValid) {
    return { invalidEmail: true };
  }
  return null;
}
